import React from 'react';
import BackIcon from '@menuzen/icon/build/outline/Back';
import classNames from 'classnames';
import { Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';

interface HeaderProps {
    showAction?: boolean;
    className?: string;
    onBack?: () => void;
    title?: string;
    onClickSecondary?: () => void;
    onClickPrimary?: () => void;
    isPrimaryLoading?: boolean;
}

const Header: React.FC<HeaderProps> = ({
    className,
    showAction,
    title,
    isPrimaryLoading,
    onBack,
    onClickSecondary,
    onClickPrimary,
}) => {
    return (
        <div className={classNames(['flex items-center', className])}>
            {onBack ? (
                <div className={`text-25 cursor-pointer flex items-center`} onClick={onBack}>
                    <BackIcon />
                    <p className="text-14 ml-3 leading-none">Dashboard</p>
                </div>
            ) : (
                <div className="h-25" />
            )}
            {title && <div className="flex-auto text-center text-16 font-semibold leading-none pr-25">{title}</div>}
            <div className={`flex-shrink-0`}>
                {showAction && (
                    <div className="flex items-center justify-between">
                        {onClickSecondary && (
                            <div className={`px-10`}>
                                <Button color="primary" size={`small`} variant={`outlined`} onClick={onClickSecondary}>
                                    Preview
                                </Button>
                            </div>
                        )}
                        {onClickPrimary && (
                            <LoadingButton
                                color="primary"
                                size={`small`}
                                variant={'contained'}
                                onClick={onClickPrimary}
                                loading={isPrimaryLoading}
                            >
                                Publish
                            </LoadingButton>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Header;
